import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'travel-ui-email-subscribe',
  templateUrl: './email-subscribe.component.html',
  styleUrls: ['./email-subscribe.component.scss']
})
export class EmailSubscribeComponent implements OnInit {
  model?: any= 
  {};
  public sucess: Boolean = false;
  constructor() { }

  onSubmit() {
    this.sucess = true;
  }




  ngOnInit() {
  }




}
